module.exports = __webpack_public_path__ + "media/MRI5-ad.04b7c7ca.mp3";